const reducer = () => {
    return null;
}

export default reducer;


// WEBPACK FOOTER //
// ./src/reducers/index.js